import React from 'react'
import ContactUsQueriesComponent from '../../../Components/AdminComponent/ContactUsQueriesComponent/ContactUsQueriesComponent'
import AdminHeader from '../../../Components/AdminComponent/AdminHeader/AdminHeader'
import AdminSidebar from '../../../Components/AdminComponent/AdminSidebar/AdminSidebar'

const ContactUsQueries = () => {
    return (
        <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>
            <AdminHeader />
            <div className='row col-lg-12'>
                <AdminSidebar />
                <div className='col-lg-10 right_content'>
                    <ContactUsQueriesComponent />

                </div>

            </div>



        </div>
    )
}

export default ContactUsQueries
